import React from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import FileUploadIcon from '../../../assets/Icons/FileUpload';
import { LinkComponent } from '../../Global/LinkComponents';

const cardStyles = () => makeStyles((theme) => ({
  linkWrapper: {
    textDecoration: 'none',
  },
  aditionalActionCard: {
    height: '100%',
  },
  header: {
    flexFlow: 'row-reverse',
    padding: '9px 9px 0 9px',
    '& svg': {
      fontSize: '37px',
    },
  },
  avatar: {
    color: theme.palette.error.light,
    fontSize: '37px',
  },
  content: {
    padding: '0 9px 0 9px',
    marginTop: '-10px',
  },
  actionArea: {
    padding: '4px 9px 16px 9px',
    '& button': {
      padding: '0',
    },
  },
  actionIcon: {
    color: theme.palette.grey.main,
    fontSize: '25px',
  },
}));

export const ActionCard = (props) => {
  const renderActionIcon = (type) => {
    switch (type) {
      case 'edit':
        return <EditIcon className={cardClass.actionIcon} />;
      case 'import':
        return <FileUploadIcon className={cardClass.actionIcon} />;
      default:
        return null;
    }
  };
  const cardClass = cardStyles(props)();
  return (
    <LinkComponent className={cardClass.linkWrapper} href={props.link}>
      <Card className={cardClass.aditionalActionCard}>
        <CardHeader className={cardClass.header} avatar={props.children} subheader={props.header} />
        <CardContent className={cardClass.content}>
          <Typography variant='h5' component='h2'>
            {props.content}
          </Typography>
        </CardContent>
        <CardActions className={cardClass.actionArea}>
          <IconButton>{renderActionIcon(props.type)}</IconButton>
        </CardActions>
      </Card>
    </LinkComponent>
  );
};
